const nameSpace = 'lucky__config';

const defaultData = {
  gcTime: '',
  length: 0,
};

class ConfigSetup {
  static nameSpace = nameSpace;
  constructor() {
    this.data = this.get();
  }
  getGcTime() {
    return this.data.gcTime;
  }
  getLength() {
    return this.data.length;
  }
  setGcTime(time) {
    this.data.gcTime = time;
  }
  addLength(num) {
    this.data.length += num;
  }
  dir() {
    const val = localStorage.getItem(nameSpace);
    if (!val) {
      return null;
    }
    return JSON.parse(val);
  }
  get() {
    let result = this.dir();
    if (!result) {
      result = { ...defaultData };
      try {
        localStorage.setItem(nameSpace, JSON.stringify(result));
      } catch (e) {
        localStorage.clear();
      }
    }
    return result;
  }
  clear() {
    this.data = { ...defaultData };
  }
  save() {
    try {
      localStorage.setItem(nameSpace, JSON.stringify(this.data));
    } catch (e) {
      localStorage.clear();
    }
  }
}

export default ConfigSetup;
